var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import createTheme from '@mui/material/styles/createTheme';
import palette from './src/palette';
import typography from './src/typography';
import transitions from './src/transitions';
import shadows from './src/shadows';
import components from './src/components';
export var defaultTheme = {
    palette: palette,
    typography: typography,
    transitions: transitions,
    shadows: shadows,
    components: components,
};
export var theme = createTheme(defaultTheme);
var ThemeProvider = function (_a) {
    var children = _a.children, palette = _a.palette;
    return (React.createElement(MuiThemeProvider, { theme: __assign(__assign({}, theme), { palette: __assign(__assign({}, theme.palette), palette) }) }, children));
};
ThemeProvider.defaultProps = {
    palette: {},
};
export default ThemeProvider;
